import { ActionStages, splitActionName } from '../common/action-utilities';

export const initialCallState = {
  isLoading: false,
  error: null,
  data: null, // this stores raw response data
};

function singleCallReducer(callState = initialCallState, stage, params) {
  const {
    callResponse = {},
    actionTime,
  } = params;

  switch (stage) {
    case ActionStages.start:
      return {
        ...callState,
        isLoading: true,
      };
    case ActionStages.complete:
      return {
        ...callState,
        lastUpdated: actionTime,
        data: callResponse,
        isLoading: false,
        error: null,
      };
    case ActionStages.fail: {
      const { error } = params;
      return {
        ...callState,
        isLoading: false,
        error,
      };
    }
    default:
      return callState;
  }
}

export function callReducer(globalState, action, callName) {
  const { params } = action;
  const { stage } = splitActionName(action);
  const {
    sideEffectFn,
    callResponse = {},
    actionTime,
    targetObject,
  } = params;

  const { mcaEntities: entityCollStates, calls: callStates } = globalState;

  // mutate state for call
  const newCallStates = { ...callStates };
  newCallStates[callName] = singleCallReducer(callStates[callName], stage, params);

  // perform side effects on entities
  const newEntityCollStates = { ...entityCollStates };
  if (sideEffectFn) {
    // we'll iterate thru all keys in the global state (i.e., all entities),
    // and call sideEffectFn on to reduce their data
    const entityCollKeys = Object.keys(entityCollStates);

    for (let i = 0; i < entityCollKeys.length; i += 1) {
      const entityCollKey = entityCollKeys[i];
      const entityCollState = entityCollStates[entityCollKey];
      newEntityCollStates[entityCollKey] = {
        ...entityCollState,
        data: sideEffectFn(entityCollKey, targetObject, stage, entityCollState.data, callResponse),
        // BUGBUG: this will update all entities' properties
        lastUpdated: stage === ActionStages.complete ? actionTime : entityCollState.lastUpdated,
      };
    }
  }

  return {
    ...globalState,
    mcaEntities: newEntityCollStates,
    calls: newCallStates,
  };
}
